import React from 'react';
import { Select } from 'antd';
// import '@style/modules/analysis/esg.scss';
import '../../../../styles/modules/analysis/esg.scss';

const ScoreIcon = ({ score, v25, v75, edit = false, onChange }) => {
  if (!edit) {
    return (
      <div className="score-icon-back">
        {score === 'NA' ? (
          <span className="score-icon-null">N/A</span>
        ) : score === 'Above' ? (
          <span
            className="appkiticon icon-arrow-up-fill a-font-16"
            style={{ color: '#006CE2' }}
          />
        ) : score === 'Industry' ? (
          <span
            className="appkiticon icon-minus-fill a-font-16"
            style={{ color: '#FFB600' }}
          />
        ) : (
          <span
            className="appkiticon icon-arrow-down-fill a-font-16"
            style={{ color: '#D04A02' }}
          />
        )}
      </div>
    );
  }

  const dropstyle = {
    display: 'inline-block',
    width: 6,
    height: 6,
    borderRadius: 3,
    marginBottom: 2,
    marginRight: 6,
  };
  return (
    <Select
      dropdownClassName="esg-select-dropdown"
      dropdownMatchSelectWidth={false}
      defaultValue={score}
      onChange={onChange}
    >
      <Select.Option value="Below">
        <div style={{ ...dropstyle, background: '#D04A02' }} />
        Below
      </Select.Option>
      <Select.Option value="Industry">
        <div style={{ ...dropstyle, background: '#FFB600' }} />
        Industry
      </Select.Option>
      <Select.Option value="Above">
        <div style={{ ...dropstyle, background: '#006CE2' }} />
        Above
      </Select.Option>
      <Select.Option value="NA">
        <div style={{ ...dropstyle, background: '#ACACAC' }} />
        Not Applicable
      </Select.Option>
    </Select>
  );
};

export default ScoreIcon;
